var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M31.718 6.358l-9.705 9.642 9.705 9.642c0.175-0.367 0.282-0.772 0.282-1.205v-16.875c0-0.433-0.106-0.838-0.282-1.205z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M29.188 4.75h-26.375c-0.433 0-0.838 0.106-1.205 0.282l12.404 12.341c1.097 1.097 2.88 1.097 3.977 0l12.404-12.341c-0.367-0.175-0.772-0.282-1.205-0.282z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M0.282 6.358c-0.175 0.367-0.282 0.772-0.282 1.205v16.875c0 0.433 0.106 0.838 0.282 1.205l9.705-9.642-9.705-9.642z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M20.688 17.326l-1.373 1.373c-1.827 1.827-4.801 1.827-6.628 0l-1.373-1.373-9.705 9.642c0.367 0.175 0.772 0.282 1.205 0.282h26.375c0.433 0 0.838-0.106 1.205-0.282l-9.705-9.642z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a55c13f63be245f2fb207505caa4e508.svg";
export { ForwardRef as ReactComponent };